import Vue from 'vue'
import '@/plugins/element'
import '@/assets/styles/element-variables.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/index.scss'
import '@/assets/styles/fonts.scss'
import authDirective from '@/directives/auth'
import authDisableDirective from '@/directives/auth-disable'
import { hasPermission, hasAnyPermission, hasAllPermissions } from '@/utils/permission'

// Element UI 全局组件尺寸（按需引入时 Vue.use 不传 size，通过此方式设置）
Vue.prototype.$ELEMENT = { size: 'medium' }

Vue.directive('auth', authDirective)
Vue.directive('auth-disable', authDisableDirective)
Vue.prototype.$auth = hasPermission
Vue.prototype.$authAny = hasAnyPermission
Vue.prototype.$authAll = hasAllPermissions

Vue.config.productionTip = false

// 移动端（小程序/App）通过 <web-view> 打开在线阅读器时，原生侧无法共享本域 localStorage，
// 故把前台登录态以 URL query `token` 透传进来，这里在应用启动前注入 localStorage，
// 供 @/utils/request 的请求拦截器读取（key 与 store 一致：wb_front_token）。
// 仅当 URL 带 token 时生效，对普通浏览器访问零影响。
try {
  const _qToken = new URLSearchParams(window.location.search).get('token')
  if (_qToken) {
    localStorage.setItem('wb_front_token', _qToken)
  }
} catch (e) { /* ignore */ }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
